<ng-container *ngIf="expandedMaterial;">
  <section class="px-2">
    <div class="grid grid-cols-2 gap-4 p-4 border rounded-lg shadow-sm bg-white relative">
      <div>
        <div class="text-sm text-gray-500">
          <div class="flex items-center gap-1 text-sm text-gray-500">
            Faltante
            <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
              <button mat-icon-button color="primary">
                <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
              </button>
            </div>

            <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
              <div class="p-4">
                <p>Cantidad No recibida</p>
              </div>
            </mat-menu>
          </div>
        </div>
        <p class="font-semibold" [ngClass]="expandedMaterial?.missing > 0 ? 'text-red-500' : 'text-black'">
          {{ expandedMaterial?.missing ?? 0 | number: "1.3-3" }}
        </p>
      </div>
      <div>
        <div class="text-sm text-gray-500">
          <div class="flex items-center gap-1 text-sm text-gray-500">
            Sobrante
            <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="spareMenu">
              <button mat-icon-button color="primary">
                <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
              </button>
            </div>

            <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #spareMenu="matMenu">
              <div class="p-4">
                <p>Cantidad recibida en exceso</p>
              </div>
            </mat-menu>
          </div>
        </div>
        <p class="font-semibold" [ngClass]="expandedMaterial?.spare > 0 ? 'text-red-500' : 'text-black'">
          {{ expandedMaterial?.spare ?? 0 | number: "1.3-3" }}
        </p>
      </div>
      <div>
        <p class="text-sm text-gray-500">Total UMB</p>
        <p class="font-semibold">{{ expandedMaterial?.totalBaseQuantity | number: "1.3-3" }}</p>
      </div>
      <div>
        <p class="text-sm text-gray-500">Total UMP</p>
        <p class="font-semibold">{{ expandedMaterial?.totalPararellQuantity | number: "1.3-3" }}</p>
      </div>

      <div class="col-span-2 flex justify-between sm:justify-end sm:absolute sm:top-2 sm:right-2 gap-2 mt-4 sm:mt-0">
        <button mat-stroked-button color="primary" (click)="closeDrawerChild()" matTooltip="Volver a materiales">
          <div class="flex items-center">
            <div class="pr-1">
              <mat-icon svgIcon="heroicons_outline:chevron-left"></mat-icon>
            </div>
            <div class="flex flex-col p-2 content-center text-center gap-[3px] min-w-[60px] w-20">
              <span class="font-light">Materiales</span>
            </div>
          </div>
        </button>
      </div>
    </div>

    <table mat-table [dataSource]="expandedMaterial.orderdetail" class="min-w-full mat-elevation-z2 mt-4" matSort
      matSortDisableClear multiTemplateDataRows>
      <ng-container matColumnDef="isNew">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left table-tittle">
          <span class="pl-3"></span>
        </th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left text-sm leading-tight">
          @if(detail.isNew){
          <mat-icon class="text-green-700 text-md" svgIcon="heroicons_outline:check-badge"></mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="note">
        <th mat-header-cell *matHeaderCellDef class="text-center">
          Nota
        </th>
        <td mat-cell *matCellDef="let detail" class="text-left text-sm leading-tight">
          <button mat-icon-button color="primary" matTooltip="{{ detail.note }}"
            [disabled]="!(detail.note && detail.note != '')">
            <mat-icon svgIcon="heroicons_outline:chat-bubble-bottom-center-text"></mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Nro. Doc -->
      <ng-container matColumnDef="noDto">
        <th mat-header-cell *matHeaderCellDef class="text-left">Nro. Doc.</th>
        <td mat-cell *matCellDef="let detail" class="text-left text-xs leading-tight">
          <p (click)="fetchOrderBySerial(detail.sourceTransaction.serial)"
            class="font-semibold text-xs underline cursor-pointer" matTooltip="Ver detalles">
            {{ detail.sourceTransaction.serial }}
          </p>
          <p class="font-semibold text-xs">
            {{ detail.serial }}
          </p>
        </td>
      </ng-container>

      <!-- Cliente -->
      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Cliente</th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left text-sm leading-tight">
          <p>
            <span class="font-bold text-xs">
              {{ detail.shipTo?.externalKeys.code }}
            </span>
            <br />
            <span>
              {{ detail.shipTo?.name }}
            </span>
          </p>
        </td>
      </ng-container>

      <!-- Cantidad -->
      <ng-container matColumnDef="soldQuantity">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Cantidad</th>
        <td mat-cell *matCellDef="let detail" class="text-sm leading-tight">
          <app-unit-measure-display
            class="f-9"
            [usedUnit]="{
              quantity: detail?.soldQuantity,
              unitId: detail?.soldUnitOfMeasure?._id,
              unitName: detail?.soldUnitOfMeasure?.name,
              unitAbbreviation: detail?.soldUnitOfMeasure?.code
            }"
            [baseUnit]="{
              quantity: detail?.baseQuantity,
              unitId: detail?.baseUnitOfMeasure?._id,
              unitName: detail?.baseUnitOfMeasure?.name,
              unitAbbreviation: detail?.baseUnitOfMeasure?.code
            }"
            [parallelUnit]="{
              quantity: detail?.pararellQuantity,
              unitId: detail?.pararellUnitOfMeasure?._id,
              unitName: detail?.pararellUnitOfMeasure?.name,
              unitAbbreviation: detail?.pararellUnitOfMeasure?.code
            }"
            [material]="{
              _id: detail?.material?._id,
              code: detail?.material?.code,
              UMPActive: detail?.material?.UMPActive ?? false
            }"
            [companyUMPActive]="UMPActive"
          ></app-unit-measure-display>
        </td>
      </ng-container>

      <ng-container matColumnDef="det">
        <th mat-header-cell *matHeaderCellDef>
          @if(expandedMaterial?.spare > 0){
          <button mat-button color="primary" (click)="openSoldToEmptyDocument()" matTooltip="Agregar">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
          }
        </th>
        <td mat-cell *matCellDef="let detail">
          <div class="flex flex-col md:flex-row items-center">
            <button mat-button color="primary" class="h-7 min-h-7 min-w-10 px-2 leading-6" (click)="onHandleEditUMBDetail(detail)" 
               matTooltip="Editar unidad de medida base" [disabled]="detail.documentStatusId !== 6">
              <mat-icon svgIcon="heroicons_outline:pencil-square"
                class="self-center">
              </mat-icon>
            </button>
            <button mat-button class="h-7 min-h-7 min-w-10 px-2 leading-6" (click)="toggleDetails(detail)">
              <mat-icon class="icon-size-5" [svgIcon]="selectedMaterialDoc?._id + selectedMaterialDoc?.position === detail?._id + detail?.position
                    ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayColumsDistributionItems.length"
          style="width: 100%;">
          <tr *ngIf="selectedMaterialDoc?._id + selectedMaterialDoc?.position === element._id + element?.position" class="details-row p-3">
            <td [attr.colspan]="displayColumsDistributionItems.length">
              <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: { $implicit: row }"></ng-container>
            </td>
          </tr>
        </td>
      </ng-container>

      <!-- Header Row -->
      <tr mat-header-row *matHeaderRowDef="displayColumsDistributionItems"
        class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900"></tr>

      <!-- Fila principal -->
      <tr mat-row *matRowDef="let element; columns: displayColumsDistributionItems;" class="border-b"
        [class.table-expanded-row]="selectedMaterialDoc?._id + selectedMaterialDoc?.position === element._id + element?.position"></tr>

      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
    </table>
  </section>
</ng-container>

<ng-template #rowDetailsTemplate let-detail>
  <div style="max-width: 100%; min-width: 100%;">
    <form class="p-2 detail-container">
      <div class="grid grid-cols-2 md:grid-cols-2 gap-2">

        <!-- Precio -->
        <div class="flex flex-col">
          <label class="font-semibold text-gray-600">Precio</label>
          <ng-container *ngIf="selectedMaterialDoc.isEditMode && selectedOrder.class.canUpdatePrices; else readOnlyPrice">
            <mat-form-field appearance="fill" floatLabel="never" class="w-full">
              <input matInput 
                type="number" 
                [(ngModel)]="selectedMaterialDoc.unitPrice"
                [ngModelOptions]="{standalone:true}"
                placeholder="Precio"
                aria-label="Precio"
                (change)="onChangePriceInOrderDetail(selectedOrder, selectedMaterialDoc)"
                (keyup)="onChangePriceInOrderDetail(selectedOrder, selectedMaterialDoc)" />
            </mat-form-field>
          </ng-container>
          <ng-template #readOnlyPrice>
            <span class="text-sm" [ngStyle]="{
              'text-decoration': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none',
              'text-decoration-color': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
            }">
              {{ selectedMaterialDoc?.unitPrice | decimalFormat }}
            </span>
          </ng-template>
        </div>

        <!-- SubTotal -->
        <div class="flex flex-col">
          <label class="font-semibold text-gray-600">SubTotal</label>
          <span class="text-sm" [ngStyle]="{
                'text-decoration': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none',
                'text-decoration-color': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
              }">
            {{ selectedMaterialDoc?.subTotal | decimalFormat }}
          </span>
        </div>

        <!-- Recargo -->
        <div class="flex flex-col">
          <label class="font-semibold text-gray-600">Recargo</label>
          <span class="text-sm" [ngStyle]="{
                'text-decoration': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none',
                'text-decoration-color': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
              }">
            {{ selectedMaterialDoc?.totalSurcharges | decimalFormat }}
          </span>
        </div>

        <!-- Descuento -->
        <div class="flex flex-col">
          <label class="font-semibold text-gray-600">Descuento</label>
          <span class="text-sm" [ngStyle]="{
                'text-decoration': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none',
                'text-decoration-color': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
              }">
            {{ selectedMaterialDoc?.totalDiscounts | decimalFormat }}
          </span>
        </div>

        <!-- Impuesto -->
        <div class="flex flex-col">
          <label class="font-semibold text-gray-600">Impuesto</label>
          <span class="text-sm" [ngStyle]="{
                'text-decoration': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none',
                'text-decoration-color': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
              }">
            {{ selectedMaterialDoc?.totalTaxes | decimalFormat }}
          </span>
        </div>

        <!-- Total -->
        <div class="flex flex-col">
          <label class="font-bold text-gray-800">Total</label>
          <span class="pr-2 text-sm font-bold" [ngStyle]="{
                'text-decoration': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none',
                'text-decoration-color': selectedMaterialDoc.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
              }">
            {{ selectedMaterialDoc?.total | decimalFormat }}
          </span>
        </div>

        <!-- Almacén -->
        <div class="flex flex-col">
          <label class="font-semibold text-gray-600">Almacén</label>
          <ng-container *ngIf="!selectedMaterialDoc.isEditMode">
            <span>
              <span *ngIf="getCode(selectedMaterialDoc.warehouse) as code" class="font-mono">{{ code }} - </span>
              {{ selectedMaterialDoc.warehouse?.name }}
            </span>
          </ng-container>
          <ng-container *ngIf="selectedMaterialDoc.isEditMode">
            <mat-form-field appearance="fill" class="w-full" floatLabel="never">
              <mat-select [(ngModel)]="selectedMaterialDoc.warehouse"
                          [ngModelOptions]="{standalone:true}"
                          [compareWith]="compareById"
                          (selectionChange)="selectedMaterialDoc.thereIsChanges = true; onChangeWarehouseInOrderDetail(selectedMaterialDoc)">
                <mat-option *ngFor="let warehouse of selectedOrder.warehousesToUpdate || []" [value]="warehouse">
                  {{ warehouse.externalKeys?.code + ' - ' + warehouse.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </div>

      </div>
    </form>
  </div>
</ng-template>

<ng-template #viewDocumentModal let-data>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">
    Documento <span class="text-semibold">{{ data.serial }}</span>
  </h2>
  <mat-dialog-content class="modal-content-update">
    <app-order-list-table [dataList]="detailOrderUnified">
    </app-order-list-table>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      Cerrar
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #unitMeasureModal let-detail>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Unidad de Medida</h2>
  <mat-dialog-content class="modal-content-update">
    <div class="flex flex-col">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Unidad de medida</mat-label>
        <mat-select [(ngModel)]="detail.selectedUnit" [ngModelOptions]="{standalone:true}">
          <mat-option [ngValue]="null" disabled selected>Selecciona una unidad</mat-option>
          <mat-option value="UMB">UMB ({{ detail.baseUnitOfMeasure?.name }})</mat-option>
          <mat-option *ngIf="UMPActive" value="UMP">UMP ({{ detail.pararellUnitOfMeasure?.name }})</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Cantidad</mat-label>
        <input matInput type="number" step="0.001" min="0" name="editbaseQuantity" placeholder="Cantidad" class="text-sm"
          [ngModel]="detail.selectedUnit == 'UMB' ? detail.baseQuantity : detail.pararellQuantity"
          (ngModelChange)="validateInput($event, detail)" (click)="$event.stopPropagation()" />
      </mat-form-field>      
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex justify-between p-4">
    <button mat-button class="align-left mr-3" (click)="inputCancelUMB(detail)">
      Cancelar
    </button>
    <button mat-raised-button color="primary" (click)="inputSaveUMB(detail)">
      Editar
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #soldToEmptyDocument>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">
    Seleccionar cliente
  </h2>
  <mat-dialog-content class="modal-content-update">
    @if(soldToList?.length > 0){
    <div class="flex flex-col">
      <mat-form-field appearance="fill" class="w-full" floatLabel="never">
        <mat-label>Cliente</mat-label>
        <mat-select [(ngModel)]="selectedSoldTo" name="soldTo">
          @for (soldTo of soldToList; track soldTo) {
          <mat-option [value]="soldTo">
            <div class="flex flex-col">
              <span class="text-sm font-semibold">{{ soldTo.soldTo?.externalKeys?.code }}</span>
              <div class="flex items-center gap-1">
                <span class="font-medium">{{ soldTo.soldTo?.name }} - {{ soldTo.serial }}</span>
              </div>
            </div>

          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Unidad de medida</mat-label>
        <mat-select [(ngModel)]="detail.selectedUnit" name="selectedUnitSoldTo" (click)="$event.stopPropagation()">
          <mat-option [ngValue]="null" disabled selected>Selecciona una unidad</mat-option>
          <mat-option value="UMB">UMB</mat-option>
          @if(UMPActive){
          <mat-option value="UMP">UMP</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Cantidad</mat-label>
        <input matInput type="text" step="0.001" min="0" name="baseQuantity" placeholder="Cantidad" class="text-sm"
          [ngModel]="detail.selectedUnit == 'UMB' ? detail.baseQuantity : detail.pararellQuantity"
          (ngModelChange)="validateInput($event, detail)" (click)="$event.stopPropagation()" />
      </mat-form-field>
    </div>
    }@else{
    <p class="text-gray-500 items-center">No hay clientes disponibles</p>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex justify-between p-4">
    <button mat-button mat-dialog-close class="align-left mr-3">
      Cancelar
    </button>
    <button mat-raised-button color="primary" (click)="saveSoldTo()">
      Guardar
    </button>
  </mat-dialog-actions>
</ng-template>